import React, { Dispatch, SetStateAction } from 'react';
import Search2LineIcon from 'remixicon-react/Search2LineIcon';
import SearchModal from '@/components/layout/search/SearchModal';
import { useSearchModalStore } from '@/stores/layout/searchModalStore';

interface SearchModalProps {
    setLoading?: Dispatch<SetStateAction<boolean>>;
    className?: string;
}

const SearchModalComponent = ({ className }: SearchModalProps) => {
    const { isOpen, openSearch, closeSearch, setIsOpen } = useSearchModalStore();

    return (
        <>
            <button
                type='button'
                aria-label='Open search modal'
                className={`flex items-center justify-center size-7 rounded-full text-zinc-700 dark:text-white hover:text-progress dark:hover:text-progress transition-colors shrink-0 ${className || ''}`}
                onClick={() => openSearch()}
            >
                <Search2LineIcon className='shrink-0' size={18} />
            </button>
            <SearchModal isModalOpen={isOpen} setIsModalOpen={setIsOpen} closeModal={closeSearch} />
        </>
    );
};

export default SearchModalComponent;
